import {NextApi} from "../Next/next";

export const GET_SPACE_BY_ID = 'GET_SPACE_BY_ID'

export const getSpaceByIdNext = new NextApi("/space/operator/spaces/{spaceId}/space/{ownerId}", GET_SPACE_BY_ID, {
  method: "GET", json: false,
});
